import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import { useAppSelector } from '~/hooks/useAppSelector';
import { type IShiftDetailsFormValues } from './ShiftDetails/ShiftDetailsForm/useShiftDetailsForm';

export const ShiftRequestLayout = () => {
  const userAssistedHygiene = useAppSelector(
    (state) => state.user.selectedChildOffice?.office_info?.isAssistedHygiene,
  );

  const methods = useForm<IShiftDetailsFormValues>({
    defaultValues: {
      dates: [],
      professionType: '',
      officeId: '',
      arrivalTime: '08:00 am',
      departureTime: '05:00 pm',
      mealBreakDuration: '',
      isMealBreakPaid: false,
      rate: null,
      preferredSpecialty: '',
      isAssistedHygiene: userAssistedHygiene ?? undefined,
      procedures: [],
      invite: [],
      inviteNames: {},
      inviteSource: 'Shift Request',
      autoConfirm: { favorites: false, eligibleProfessionals: false },
      shiftOverrides: {},
    },
  });

  // Reset dependent fields when professionType changes
  const previousProfessionTypeRef = useRef(methods.getValues('professionType'));

  useEffect(() => {
    const subscription = methods.watch((values, { name }) => {
      if (
        name === 'professionType' &&
        values.professionType !== previousProfessionTypeRef.current
      ) {
        previousProfessionTypeRef.current = values.professionType || '';
        methods.setValue('rate', null);
        methods.setValue('preferredSpecialty', '');
        methods.setValue('procedures', []);
        methods.setValue('autoConfirm', { favorites: false, eligibleProfessionals: false });
      }
    });
    return () => subscription.unsubscribe();
  }, [methods]);

  return (
    <FormProvider {...methods}>
      <Outlet />
    </FormProvider>
  );
};
